





































import Vue from 'vue';
import { confirmDialog } from './Confirm';
import { Preferences } from './Preference';


export default Vue.extend({
  data: () => confirmDialog,
  computed: {
    dontShow: {
      get(): boolean {
        return this.pref ? Preferences.get(this.pref, false) : false;
      },
      set(value: boolean) { 
        if (this.pref) {
          Preferences.set(this.pref, value);
        }
      },
    },
    dontShowHint(): string {
      if (!this.pref) {
        return '';
      }

      return Preferences.getPreference(this.pref).label;
    },
  },
});
